import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=4648ee52&scoped=true&"
import script from "./SearchPage.vue?vue&type=script&lang=js&"
export * from "./SearchPage.vue?vue&type=script&lang=js&"
import style0 from "./SearchPage.vue?vue&type=style&index=0&id=4648ee52&lang=scss&scoped=true&"
import style1 from "./SearchPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4648ee52",
  null
  
)

export default component.exports